import React, { Component } from 'react';
import SimpleSliderDruckfarbe from './c_slider_druckfarbe';
import SimpleSliderTextil from './c_slider_textil';

import druckSmall from '../../../assets/icons/ICN_Druck_small.svg';
import textilSmall from '../../../assets/icons/ICN_Textil_small.svg';

import Lang from '../../../i18n'
import { withRouter } from 'react-router-dom'

var classNames = require('classnames');

class SliderGroup extends Component{
  constructor(props) {
    super(props);
    this.handleChangeColor = this.handleChangeColor.bind(this);
    this.handleChangeTextile = this.handleChangeTextile.bind(this);
  }

  handleChangeColor(selected) {
    this.props.onChangeColor(selected);
  }

  handleChangeTextile(selected) {
    this.props.onChangeTextile(selected);
  }

  render() {
    const styles = this.props.styles;
    return(
      <div className={classNames(styles.inputItem, styles.modulRegulator)}>
          <SimpleSliderDruckfarbe
            styles={styles}
            onChange={this.handleChangeColor}
            name="druck"
            defaultValue={this.props.printColorPercentage}
            textilePercentage={this.props.textileColorPercentage}
            label={Lang.translate('calculator:printColor', this.props.location.pathname)}
            white={Lang.translate('calculator:white', this.props.location.pathname)}
            showPercentage='true'
            icon={druckSmall}
          />
          <SimpleSliderTextil
            styles={styles}
            onChange={this.handleChangeTextile}
            name="textile"
            defaultValue={this.props.textileColorPercentage}
            label={Lang.translate('calculator:textileColor', this.props.location.pathname)}
            white={Lang.translate('calculator:white', this.props.location.pathname)}
            colourful={Lang.translate('calculator:colourful', this.props.location.pathname)}
            dark={Lang.translate('calculator:dark', this.props.location.pathname)}
            showPercentage='true'
            icon={textilSmall}
          />
      </div>
    );
  }
}

export default withRouter(SliderGroup);



// WEBPACK FOOTER //
// ./src/components/calculator/inputs/c_slider_group.js